import LoadScript from 'vue-plugin-load-script'

export default {
  install (Vue, options) {
    Vue.use(LoadScript)

    // 1. add global method or property
    let isInit = false
    let user = null

    function init () {
      return new Promise((resolve, reject) => {
        isInit = true
        resolve(null)
      })
    }

    function initUser () {
      return new Promise((resolve, reject) => {
        init().then(() => {
          if (user === null) {
            let tmpUser = Vue.auth.user()
            if (Object.keys(tmpUser).length !== 0 && tmpUser.constructor === Object) {
              user = tmpUser
            }
            resolve(null)
          } else {
            resolve(null)
          }
        })
      })
    }

    function createContact () {
      initUser().then(() => {
        if (user !== null) {
          if (typeof _cio !== 'undefined' && typeof _cio.identify === 'function' &&
            (typeof user !== 'undefined' && typeof user.email !== 'undefined')) {
            _cio.identify({
              id: process.env.NODE_ENV + '_' + user.id,
              email: user.email,
              first_name: user.firstName,
              last_name: user.lastName,
              profile_name: user.profile.name,
              is_email_confirmed: user.is_email_verified,
              phone_number: user.phone,
              company: (user.company) ? user.company.name : user.company_name,
              account_uid: user.profile.id,
              plan_name: user.plan_name,
              expired_at: user.plan.expired_at,
              role_name: user.role_name,
              hasReceiveQuestion: user.receiveQuestion,
              isProfileEdited: !!(typeof user.expert !== 'undefined' && user.expert.length),
              isOpenForCollaboration: typeof user.expert !== 'undefined' && user.expert.length ? user.expert[0].is_open_for_collaboration : null
            })
          }
        }
      })
    }

    function _cioTrack (eventName, options) {
      initUser().then(() => {
        if (user !== null && typeof _cio !== 'undefined' && _cio.track && _cio.identify) {
          _cio.identify({
            id: process.env.NODE_ENV + '_' + user.id,
            email: user.email,
            id_secure: process.env.NODE_ENV + '_' + user.id
          })
          setTimeout(() => { _cio.track(eventName) }, 4000)
        }
      })
    }

    Vue.prototype.$salesMachine = {
      signIn: () => {
        createContact()
        _cioTrack('user_login')
      },
      signUp: () => {
        createContact()
        _cioTrack('user_registration')
      },
      accountEnabled: () => {
        createContact()
        _cioTrack('account_enabled')
      },
      setOpenInnovationScore: (OIScore) => {
        initUser().then(() => {
          if (user !== null && OIScore) {
            if (typeof _cio !== 'undefined' && typeof _cio.identify === 'function' &&
              (typeof user !== 'undefined' && typeof user.email !== 'undefined')) {
              _cio.identify({
                id: process.env.NODE_ENV + '_' + user.id,
                open_innovation_score: OIScore
              })
            }
          }
        })
      },
      setTrialStartDate: (startDate) => {
        initUser().then(() => {
          if (user !== null && startDate) {
            if (typeof _cio !== 'undefined' && typeof _cio.identify === 'function' &&
              (typeof user !== 'undefined' && typeof user.email !== 'undefined')) {
              _cio.identify({
                id: process.env.NODE_ENV + '_' + user.id,
                trial_start_date: startDate
              })
            }
          }
        })
      },
      editUser: (contact) => {
        user = null
        if (typeof _cio !== 'undefined' && typeof _cio.identify === 'function' &&
          (typeof contact !== 'undefined' && typeof contact.email !== 'undefined')) {
          let user = contact
          _cio.identify({
            id: process.env.NODE_ENV + '_' + user.id,
            email: user.email,
            first_name: user.firstName,
            last_name: user.lastName,
            profile_name: user.profile.name,
            plan_name: user.plan_credit.plan.name,
            role_name: user.role_name,
            is_email_confirmed: user.is_email_verified,
            phone_number: user.phone,
            company: (user.company) ? user.company.name : user.company_name,
            account_uid: user.profile.id,
            expired_at: user.plan_credit.expired_at
          })
        }
      },
      newSearch: (options) => {
        if (typeof options.nbAuthors !== 'undefined' && options.nbAuthors === 0) {
          _cioTrack('search_empty')
        } else {
          switch (options.searchtype) {
            case 'company':
              _cioTrack('search_not_empty_in_company')
              break
            case 'patents':
              _cioTrack('search_not_empty_in_patents')
              break
            case 'news' :
              _cioTrack('search_not_empty_in_news')
              break
            case 'aichat' :
              _cioTrack('search_not_empty_in_aichat')
              break
            default:
              _cioTrack('search_not_empty_in_science')
              break
          }
        }
      },
      addItem: (options) => {
        switch (options.type) {
          case 'company':
            _cioTrack('add_company_to_list')
            break
          default:
            _cioTrack('add_expert_to_list')
            break
        }
      },
      removeItem: (options) => {
        _cioTrack('remove_from_list')
      },
      mergeItem: (options) => {
        _cioTrack('merge_company')
      },
      exportCsvExpertList: (options) => {
        _cioTrack('export_experts_list')
      },
      visitSubscriptionPlan: () => {
        _cioTrack('visit_subscription_plan')
      },
      initPaymentProcess: () => {
        _cioTrack('init_payment_process')
      },
      stripeCheckout: () => {
        _cioTrack('stripe_checkout')
      },
      paymentSuccess: () => {
        _cioTrack('payment_success')
      },
      addDocToBiblio: (options) => {
        _cioTrack('doc_saved')
      },
      addSuggToBiblio: (options) => {
        _cioTrack('suggestion_saved')
      },
      addWikiToBiblio: (options) => {
        _cioTrack('wiki_saved')
      },
      createList: (options) => {
        _cioTrack('create_list')
      },
      createProject: (options) => {
        _cioTrack('create_project')
      },
      shareProject: (options) => {
        _cioTrack('shared_project')
      },
      shareResult: (options) => {
        _cioTrack('shared_search_result')
      },
      shareDocument: (options) => {
        _cioTrack('shared_document')
      },
      createDraftQuestion: (options) => {
        _cioTrack('create_draft_question')
      },
      createQuestion: (options) => {
        _cioTrack('create_question')
      },
      validateQuestion: (options) => {
        _cioTrack('validate_question')
      },
      requestValidateQuestion: (options) => {
        _cioTrack('request_validate_question')
      },
      addKeywordToBiblio: (options) => {
        _cioTrack('add_keyword_to_biblio')
      },
      clearUser: () => {
        user = null
      },
      editExpertProfile: () => {
        user = null
        createContact()
        _cioTrack('edit_expert_profile')
      }
    }

    // 3. inject some component options
    Vue.mixin({
      beforeCreate: function () {
        if (!this.$parent) {
          init()
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/plugins/salesmachine/index.js